import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getBlankCriteria, getBlankRecord, getBlankSapTestingRecord } from "./helpers";
import { getInitialState, getUnloadedState } from "./state";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },

  [mutation.LIST_SET_CRITERIA](state, searchCriteria) {
    stateMerge(state.listing.criteria, searchCriteria);
  },
  [mutation.LIST_CLEAR_CRITERIA](state) {
    state.listing.criteria = getBlankCriteria();
  },
  [mutation.LIST_SET_CRITERIA_DESCRIPTION](state, criteriaInfo) {
    state.listing.criteriaInfo = criteriaInfo;
  },
  [mutation.LIST_SET_PAGING](state, paging) {
    stateMerge(state.listing.paging, paging);
  },
  [mutation.LIST_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.LIST_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.LIST_SUCCEEDED](state, results) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = results;
  },

  [mutation.EXPORT_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.EXPORT_SUCCEEDED](state) {
    state.listing.loading = false;
  },
  [mutation.EXPORT_FAILED](state) {
    state.listing.loading = false;
  },

  [mutation.SAP_TEST_BLANK](state) {
    state.sapTestReading.loading = false;
    state.sapTestWriting.saving = false;
    state.sapTestReading.data = getBlankSapTestingRecord();
    state.sapTestWriting.data = null;
    state.sapTestReading.successful = null;
    state.sapTestWriting.successful = null;
  },
  [mutation.SAP_TEST_READING_STARTED](state) {
    state.sapTestReading.loading = true;
    state.sapTestReading.data = getBlankSapTestingRecord();
    state.sapTestReading.successful = null;
  },
  [mutation.SAP_TEST_READING_SUCCEEDED](state, result) {
    state.sapTestReading.loading = false;
    state.sapTestReading.successful = true;
    state.sapTestReading.data = result;
  },
  [mutation.SAP_TEST_READING_FAILED](state) {
    state.sapTestReading.successful = false;
    state.sapTestReading.loading = false;
  },
  [mutation.SAP_TEST_WRITING_STARTED](state) {
    state.sapTestWriting.saving = true;
    state.sapTestWriting.data = null;
    state.sapTestWriting.successful = null;
  },
  [mutation.SAP_TEST_WRITING_SUCCEEDED](state, result) {
    state.sapTestWriting.saving = false;
    state.sapTestWriting.successful = true;
    state.sapTestWriting.data = result;
  },
  [mutation.SAP_TEST_WRITING_FAILED](state) {
    state.sapTestWriting.successful = false;
    state.sapTestWriting.saving = false;
  },

  [mutation.VIEW_NEXT](state, next) {
    stateMerge(state.view.next, next);
  },
  [mutation.VIEW_PREVIOUS](state, previous) {
    stateMerge(state.view.previous, previous);
  },
  [mutation.VIEW_CLEAR](state) {
    state.view.loading = false;
    state.view.loaded = false;
    state.view.data = getBlankRecord();
  },
  [mutation.VIEW_STARTED](state, providerId) {
    state.view.loading = true;
    state.view.providerId = providerId;
  },
  [mutation.VIEW_FAILED](state) {
    state.view.loading = false;
    state.view.loaded = false;
  },
  [mutation.VIEW_SUCCEEDED](state, provider) {
    state.view.loading = false;
    state.view.loaded = true;
    stateMerge(state.view.data, provider);
    state.view.breadcrumbs = [];
    state.view.breadcrumbs.push({
      text: "Providers",
      path: "/providers"
    });
    state.view.breadcrumbs.push({
      text: provider.name
    });
  },

  [mutation.AUTOCOMPLETE_STARTED](state) {
    state.autocomplete.loading = true;
  },
  [mutation.AUTOCOMPLETE_SUCCEEDED](state, results) {
    state.autocomplete.loading = false;
    state.autocomplete.data = results;
  },
  [mutation.AUTOCOMPLETE_FAILED](state) {
    state.autocomplete.loading = false;
  },

  [mutation.RISK_PROFILE_HELP_FAILED](state) {
    state.riskProfileHelp.loading = false;
  },
  [mutation.RISK_PROFILE_HELP_STARTED](state, providerId) {
    state.riskProfileHelp.loaded = false;
    state.riskProfileHelp.loading = true;
    state.riskProfileHelp.providerId = providerId;
  },
  [mutation.RISK_PROFILE_HELP_SUCCEEDED](state, data) {
    state.riskProfileHelp.loading = false;
    state.riskProfileHelp.loaded = true;
    state.riskProfileHelp.data = data;
  },

  [mutation.RISK_PROFILE_UPFRONT_FAILED](state) {
    state.riskProfileUpfront.loading = false;
  },
  [mutation.RISK_PROFILE_UPFRONT_STARTED](state, providerId) {
    state.riskProfileUpfront.loaded = false;
    state.riskProfileUpfront.loading = true;
    state.riskProfileUpfront.providerId = providerId;
  },
  [mutation.RISK_PROFILE_UPFRONT_SUCCEEDED](state, data) {
    state.riskProfileUpfront.loading = false;
    state.riskProfileUpfront.loaded = true;
    state.riskProfileUpfront.data = data;
  },

  [mutation.RISK_PROFILE_VSL_FAILED](state) {
    state.riskProfileVsl.loading = false;
  },
  [mutation.RISK_PROFILE_VSL_STARTED](state, providerId) {
    state.riskProfileVsl.loaded = false;
    state.riskProfileVsl.loading = true;
    state.riskProfileVsl.providerId = providerId;
  },
  [mutation.RISK_PROFILE_VSL_SUCCEEDED](state, data) {
    state.riskProfileVsl.loading = false;
    state.riskProfileVsl.loaded = true;
    state.riskProfileVsl.data = data;
  }
};
